import { GET_SMC_LIST, UPDATE_SMC_USER } from "../actions/SMCActions";

const initialState = {// initialize states
    smcuser: [],
    // status: true,
};

const SMCReducer = function (state = initialState, action) {
    switch (action.type) {
      case GET_SMC_LIST: {// save smc data into state
        return { ...state, smcuser: (action.payload.data)?action.payload.data:[] };
      }
      // case UPDATE_SMC_USER: {
      //   return { ...state, status: action.status };
      // }
      default: {
        return {
          ...state,
        };
      }
    }
  };
  
  export default SMCReducer;
  
  